import React, { useCallback, useEffect } from 'react';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header/index';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import Select from 'components/inputs/Select';
import Button from 'components/inputs/Button';
import * as Yup from 'yup';
import { CREATE_MULTIPLE_VEHICLE, CREATE_VEHICLE, GET_VEHICLE, UPDATE_VEHICLE } from 'actions/vehicle';
import { FETCH_USER } from 'actions/user';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';
import { FETCH_VEHICLE_MAKE } from 'actions/vehicleMake';
import { FETCH_VEHICLE_MODEL } from 'actions/vehicleModel';
// import moment from 'moment';
// import DatePickerInput from 'components/inputs/DatePickerInput';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from 'components/common/constant';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import FileSaver from 'file-saver';
import { GiSwipeCard } from 'react-icons/gi';
import fileDownload from 'js-file-download';
import CheckBox from 'components/inputs/CheckBox';

const VehicleSchema = Yup.object().shape({
  make: Yup.string().required('Vehicle make is  required!'),
  model: Yup.string().required('Vehicle model is required!'),
  mac: Yup.string().required('Vehicle MAC is  required!'),
  vin_num: Yup.string().required('Vehicle registration no is required!'),
  owner: Yup.string().required('Vehicle owner is required!'),
  plateNumber: Yup.string().required('Vehicle plate number is required!'),
  is_auto_charge_enabled: Yup.boolean().default(true),
});

const VehicleForm = () => {
  const dispatch = useDispatch();
  const { vehicleId } = useParams();

  const vehicleDetail = useSelector((state) => state.vehicle.vehicleDetail);
  const allVehicleMake = useSelector((state) => state.vehicleMake.vehicleMakes);
  const allVehicleModel = useSelector((state) => state.vehicleModel.vehicleModels);
  const allUserData = useSelector((state) => state.user.users);
  const profileDetail = useSelector((state) => state.profile.userProfile);
  const tenantId = _.get(profileDetail, 'tenant', '');
  const makePage = useSelector((state) => state.vehicleMake.page);
  const modelPage = useSelector((state) => state.vehicleModel.page);
  const makeTotalPage = useSelector((state) => state.vehicleMake.totalPages);
  const modelTotalPage = useSelector((state) => state.vehicleModel.totalPages);

  const sampleVehicleList = [
    {
      make: '',
      model: '',
      owner: '',
      plateNumber: '',
      vin_num: '',
      mac: '',
    },
  ];

  const initialValues =
    vehicleId && !_.isEmpty(vehicleDetail)
      ? {
          ...vehicleDetail,
          owner: _.get(vehicleDetail, 'owner.id', ''),
          tenant: _.get(vehicleDetail, 'tenant.id', ''),
          ownership_type: _.get(vehicleDetail, 'ownership_type', 'b2b'),
          vin_num: _.get(vehicleDetail, 'vin_num', '').toString(),
          plateNumber: _.get(vehicleDetail, 'plateNumber', '').toString(),
        }
      : {
          vin_num: '',
          make: '',
          model: '',
          mac: '',
          max_charging_capacity: '',
          plateNumber: '',
          owner: '',
          documents: [],
          ownership_type: 'b2b',
          is_auto_charge_enabled: true,
        };

  const getVehicleDetails = useCallback((id) => {
    dispatch({ type: GET_VEHICLE, payload: id });
  }, []);

  const getAllUsers = useCallback((data) => {
    dispatch({ type: FETCH_USER, payload: data ? data : {} });
  }, []);

  useEffect(() => {
    if (vehicleId) {
      getVehicleDetails(vehicleId);
    }
  }, [vehicleId]);

  const addVehicle = useCallback((data) => {
    dispatch({
      type: CREATE_VEHICLE,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          setTimeout(() => {
            window.location.href = '/vehicles';
          }, 1000);
        }
      },
    });
  }, []);

  const addMultipleVehicle = useCallback((data) => {
    dispatch({
      type: CREATE_MULTIPLE_VEHICLE,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === 200) {
          toast.success('Vehicle added successfully');
          fileDownload(res.data, `${'Vehicle List Added'}.xlsx`);
          setTimeout(() => {
            window.location.href = '/vehicles';
          }, 1000);
        }
      },
    });
  }, []);

  const editVehicleDetail = useCallback((data) => {
    dispatch({
      type: UPDATE_VEHICLE,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          setTimeout(() => {
            window.location.href = '/vehicles';
          }, 1000);
        }
      },
    });
  }, []);

  const getAllVehicleMake = useCallback((data = {}) => {
    dispatch({ type: FETCH_VEHICLE_MAKE, payload: data });
  }, []);

  const getVehicleModelByMake = useCallback((data = {}) => {
    dispatch({ type: FETCH_VEHICLE_MODEL, payload: data });
  }, []);

  useEffect(() => {
    getAllVehicleMake();
    getAllUsers({ role: 'doco', limit: 9999 });
  }, []);

  useEffect(() => {
    if (vehicleId && !_.isEmpty(vehicleDetail) && !_.isEmpty(allVehicleMake)) {
      const selectedMake = _.find(allVehicleMake, { name: _.get(vehicleDetail, 'make', '') });
      if (selectedMake && !_.isEmpty(selectedMake) && _.has(selectedMake, 'id')) {
        getVehicleModelByMake({ makeId: selectedMake.id });
      }
    }
  }, [vehicleId, vehicleDetail, allVehicleMake]);

  const upload = () => {
    //upload a excel file and get data of uploaded excel
    const fileUpload = document.getElementById('fileUpload');
    const regex = /^([a-zA-Z0-9\s_\\.\-:()])+(.xls|.xlsx)$/;
    if (regex.test(fileUpload.value.toLowerCase())) {
      // let fileName = fileUpload.files[0].name;
      if (typeof FileReader !== 'undefined') {
        const reader = new FileReader();
        if (reader.readAsBinaryString) {
          reader.onload = () => {
            processExcel(reader.result);
          };
          reader.readAsBinaryString(fileUpload.files[0]);
        }
      } else {
        toast.error('This browser does not support HTML5.');
      }
    } else {
      toast.error('Please upload a valid Excel file.');
    }
  };

  const processExcel = (data) => {
    const workbook = XLSX.read(data, { type: 'binary' });
    const firstSheet = workbook.SheetNames[0];
    const excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
    _.map(excelRows, (data) => {
      data.documents = [];
      data.max_charging_capacity = '10';
      data.model = data.model.toString();
      data.ownership_type = 'b2b';
    });
    addMultipleVehicle(excelRows);
  };

  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const downloadSampleVehicleList = (file, fileName) => {
    // download static Excel file
    const ws = XLSX.utils.json_to_sheet(file);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };

    // Adjust column widths based on content length
    const wscols = [];
    XLSX.utils.sheet_to_json(ws, { header: 1 }).forEach((row) => {
      row.forEach((col, i) => {
        if (!wscols[i]) {
          wscols[i] = { wch: 0 };
        }
        if (col && col.toString().length + 2 > wscols[i].wch) {
          wscols[i].wch = col.toString().length + 2;
        }
      });
    });
    ws['!cols'] = wscols;

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <React.Fragment>
      <LayoutContainer>
        <AdminHeader title={`${vehicleId ? 'Edit' : 'Add'} Vehicle`} backTo="/vehicles" />
        <div className="page-content-wrapper scrollable">
          <div className="add-vehicle-page-main">
            <Card className="vehicle-form-card">
              <div className="vehicle-form__block">
                <Formik
                  enableReinitialize={!!vehicleId}
                  initialValues={initialValues}
                  validationSchema={VehicleSchema}
                  onSubmit={(values, { setSubmitting }) => {
                    if (vehicleId) {
                      // edit tenant api call....
                      const vehicleData = _.omit(values, ['createdAt', 'updatedAt', 'allowedStations']);
                      const charging_capacity = _.map(allVehicleModel, (item) => item.max_charging_capacity);
                      editVehicleDetail({
                        ...vehicleData,
                        // delete below tenant, when vehicle-data have the tenant-data
                        tenant: values.tenant ? values.tenant : tenantId,
                        max_charging_capacity: charging_capacity.toString(),
                      });
                    } else {
                      //add tenant api call...
                      const charging_capacity = _.map(allVehicleModel, (item) => item.max_charging_capacity);
                      addVehicle({
                        ...values,
                        max_charging_capacity: charging_capacity.toString(),
                      });
                    }
                    setSubmitting(false);
                  }}
                >
                  {({ values, errors, touched, handleSubmit, handleChange, setFieldValue, isSubmitting }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="vehicle-form__inner">
                        <Row>
                          <Col lg={6} md={12}>
                            <Select
                              isRequired
                              className="mb-4"
                              label="Vehicle Brand"
                              options={_.map(allVehicleMake, (item) => {
                                return { label: item?.name, value: item?.name };
                              })}
                              placeholder="Select Brand"
                              value={values.make}
                              name="make"
                              onMenuScrollDown={true}
                              getDataOnScrollDown={getAllVehicleMake}
                              page={makePage}
                              totalPage={makeTotalPage}
                              onChange={(val) => {
                                setFieldValue(`make`, val);
                                const currentMake = _.find(allVehicleMake, { name: val });
                                getVehicleModelByMake({ makeId: currentMake.id });
                              }}
                              error={errors.make && touched.make ? errors.make : null}
                            />
                          </Col>

                          <Col lg={6} md={12}>
                            <Select
                              isRequired
                              className="mb-4"
                              placeholder="Select model"
                              options={_.map(allVehicleModel, (item) => {
                                return { label: item?.model, value: _.find(allVehicleModel, { id: item?.id })?.model };
                              })}
                              label="Vehicle Model"
                              name="model"
                              value={values.model}
                              onMenuScrollDown={true}
                              getDataOnScrollDown={(data) => getVehicleModelByMake({ ...data, makeId: values.make })}
                              page={modelPage}
                              totalPage={modelTotalPage}
                              onChange={(val) => setFieldValue(`model`, val)}
                              error={errors.model && touched.model ? errors.model : null}
                            />
                          </Col>

                          <Col lg={6} md={12}>
                            <Select
                              isRequired
                              label="Vehicle Owner"
                              placeholder="Select owner"
                              options={_.map(allUserData, (item) => {
                                return { label: _.startCase(item.company), value: item.id };
                              })}
                              name="owner"
                              value={values.owner}
                              onChange={(val) => setFieldValue('owner', val)}
                              error={errors.owner && touched.owner ? errors.owner : null}
                            />
                          </Col>

                          <Col lg={6} md={12}>
                            <TextInput
                              isRequired
                              label="Plate Number"
                              placeholder="Plate Number"
                              name="plateNumber"
                              value={values.plateNumber}
                              onChange={handleChange}
                              error={errors.plateNumber && touched.plateNumber ? errors.plateNumber : null}
                            />
                          </Col>

                          <Col lg={6} md={12}>
                            <TextInput
                              isRequired
                              label="VIN Number"
                              placeholder="VIN Number"
                              name="vin_num"
                              value={values.vin_num}
                              onChange={handleChange}
                              error={errors.vin_num && touched.vin_num ? errors.vin_num : null}
                            />
                          </Col>

                          <Col lg={6} md={12}>
                            <TextInput
                              isRequired
                              label="MAC"
                              placeholder="MAC"
                              name="mac"
                              value={values.mac}
                              onChange={handleChange}
                              error={errors.mac && touched.mac ? errors.mac : null}
                            />
                          </Col>
                        </Row>
                        <Row>
                          {!vehicleId && (
                            <Col lg={6} md={12}>
                              <div className="import-vehicle-block">
                                <TextInput label="Import Vehicle File" type="file" onChange={upload} name="fileUpload" id="fileUpload" />
                                <span className="download-sample--block">
                                  <div className="download-sample-file" onClick={() => downloadSampleVehicleList(sampleVehicleList, 'vehicleList')}>
                                    <GiSwipeCard color="#58d37d" size={20} /> (Download Sample Vehicle List)
                                  </div>
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col lg={12} md={12}>
                            <label htmlFor="is_auto_charge_enabled" className="auto-charge-label">
                              Auto Charge
                            </label>
                            <CheckBox
                              name="is_auto_charge_enabled"
                              checked={values.is_auto_charge_enabled}
                              onChange={(e) => setFieldValue('is_auto_charge_enabled', e.target.checked)}
                            />
                          </Col>
                        </Row>
                      </div>
                      <div className="vehicle-save--btn--block">
                        <Button type="submit" className="vehicle-save-btn save--btn" disabled={isSubmitting}>
                          {vehicleId ? 'Edit' : 'Save and Add'} Vehicle
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Card>
          </div>
        </div>
      </LayoutContainer>
    </React.Fragment>
  );
};
export default VehicleForm;
